import React from 'react';
import { motion, AnimatePresence, useDragControls, Reorder } from 'framer-motion';
import { Lightbulb, X, GripHorizontal } from 'lucide-react';

interface HintPopupProps {
  hint: string;
  position: { x: number; y: number };
  onClose: () => void;
  isLoading?: boolean;
}

export default function HintPopup({ hint, position, onClose, isLoading = false }: HintPopupProps) {
  const dragControls = useDragControls();

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="fixed z-50 w-80"
        style={{
          left: `${position.x}px`,
          top: `${position.y + 10}px`,
        }}
        drag
        dragControls={dragControls}
        dragMomentum={false}
        dragElastic={0}
      >
        <div className="bg-white rounded-lg shadow-xl border border-gray-200 p-4">
          <div className="flex items-start justify-between gap-2 mb-3">
            <div 
              className="flex items-center gap-2 text-[#512BD4] flex-1 cursor-move"
              onPointerDown={(e) => dragControls.start(e)}
            >
              <GripHorizontal className="w-5 h-5 text-gray-400" />
              <Lightbulb className="w-5 h-5" />
              <span className="text-sm font-medium">Quick Hint</span>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors rounded-full p-1 hover:bg-gray-100"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          
          <div className="max-h-48 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
            {isLoading ? (
              <div className="flex items-center justify-center py-4">
                <div className="w-5 h-5 border-2 border-[#512BD4] border-t-transparent rounded-full animate-spin" />
              </div>
            ) : (
              <p className="text-sm text-gray-600 leading-relaxed">
                {hint}
              </p>
            )}
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
} 